import React from "react";
import { twMerge } from "tailwind-merge";
import { useNaviProduct } from "../../hooks/useNaviProduct";
import { mergeClass } from "../../utils/common";
import CdnImage from "../image/CdnImage";
import Icon from "../image/Icon";
import { icPremiumPlusTag } from "../image/image-src";
import { ProdCardBottom } from "./CardBottom";

const ProdCard: React.FC<
  ProductBaseResponse & {
    contentOnly?: boolean;
    className?: string;
    home?: boolean;
    readonly?: boolean;
    loading?: "eager" | "lazy";
  }
> = (p) => {
  const { naviProduct } = useNaviProduct();
  return (
    <div
      className={mergeClass(
        "relative flex h-full w-full flex-col md:w-auto",
        p.contentOnly
          ? ""
          : twMerge(
              "overflow-hidden rounded-[0.9375rem] shadow-md",
              p.className,
            ),
      )}
    >
      {!!p.premiumPlusPrice && (
        <span className="absolute right-[0.5rem] top-[0.5rem] z-[2]">
          <Icon src={icPremiumPlusTag} />
        </span>
      )}
      <div
        className="flex h-full flex-col items-start text-center"
        role="button"
        onClick={() => {
          if (p.readonly) return;
          naviProduct(p);
        }}
      >
        {/* <div className="relative w-full pt-[66.67%]"> */}
        <CdnImage
          src={p.thumbnail}
          alt={p.name}
          // className="absolute left-0 top-0 h-full w-full object-cover"
          // className={
          //   "w-full object-cover " + (p.home ? "h-[18.375rem]" : "h-[10rem]")
          // }
          cdnParams={{
            height: 300,
            width: 450,
            format: "webp",
            fit: "cover",
          }}
          loading={p.loading}
        />
        {/* </div> */}
        <ProdCardBottom {...p} />
      </div>
    </div>
  );
};

export default ProdCard;
